import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tip",
  "use": "icon-tip-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" class=\"design-iconfont\" id=\"icon-tip\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#C5CAD5\" d=\"M7 0A7 7 0 1 0 7 14A7 7 0 1 0 7 0Z\" />\n    <path fill=\"#FFF\" d=\"M6 6H8V11H6z\" />\n    <path fill=\"#FFF\" d=\"M6 3H8V5H6z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol